import { Icon } from '@eventbrite/eds-icon';
import { CalendarChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    Detail,
    DetailContent,
    DetailHeading,
    DetailIcon,
    ICON_SIZE,
} from '../../../_shared/Detail/Detail';
import './DateAndTime.scss';

export type DateAndTimeProps = {
    displayDate: string;
    displayEndDateWithTz: string;
    displayStartDateWithTz: string;
    doorTime: string | null;
    doorTimeLineOne?: string;
    doorTimeLineTwo?: string;
    doorTimeLineThree?: string;
    dateLineTwo: string;
    dateLineOne: string;
    hideStartDate: boolean;
    hideEndDate: boolean;
    isSameStartEndDate: boolean;
    shouldShowDoorTime: string | null;
};

export const DateAndTime = ({
    displayDate,
    displayEndDateWithTz,
    displayStartDateWithTz,
    dateLineTwo,
    dateLineOne,
    hideStartDate,
    hideEndDate,
    isSameStartEndDate,
    shouldShowDoorTime,
    doorTime,
    doorTimeLineOne,
    doorTimeLineTwo,
    doorTimeLineThree,
}: DateAndTimeProps) => {
    if (!displayDate) {
        return null;
    }

    const LABEL_ID = 'date-time-heading';
    let separator = '';

    const formattedDateTime = () => {
        const shouldShowDoorTimeLineTwo =
            (!isSameStartEndDate && !hideEndDate) || hideStartDate;
        const shouldRenderComma =
            isSameStartEndDate && !hideEndDate && !hideStartDate && !doorTime;
        const shouldRenderSpace = !isSameStartEndDate;
        if (shouldRenderComma) {
            separator = ', ';
        } else if (shouldRenderSpace) {
            separator = ' ';
        }

        const MusicEventDateTime = () => (
            <>
                {doorTimeLineOne}
                {separator}
                <span className="date-and-time__line-break">
                    {shouldShowDoorTimeLineTwo ? doorTimeLineTwo : ''}
                </span>
                {doorTimeLineThree && `, ${doorTimeLineThree}`}
            </>
        );
        const DefaultEventDateTime = () => (
            <>
                {dateLineOne}
                {separator}
                <span className="date-and-time__line-break">{dateLineTwo}</span>
            </>
        );

        return shouldShowDoorTime ? (
            <MusicEventDateTime />
        ) : (
            <DefaultEventDateTime />
        );
    };

    const DateTimeLines = () => (
        <>
            <div className="date-and-time">
                <meta
                    content={displayStartDateWithTz}
                    data-testid="event-start-date-tz"
                />
                <meta
                    content={displayEndDateWithTz}
                    data-testid="event-end-date-tz"
                />
                <time>{formattedDateTime()}</time>
            </div>
        </>
    );

    return (
        <Detail ariaLabelledBy={LABEL_ID}>
            <DetailIcon>
                <Icon
                    type={<CalendarChunky />}
                    size={ICON_SIZE}
                    isBlockLevel={true}
                />
            </DetailIcon>
            <DetailContent>
                <DetailHeading>
                    <h3 id={LABEL_ID}>{gettext('Date and time')}</h3>
                </DetailHeading>
                <DateTimeLines />
            </DetailContent>
        </Detail>
    );
};
